<template>
	<div class="flex flex_between">
		<md-field :class="[{ 'md-error': error }]">
			<label>{{ label }}</label>
			<TbSelect
				v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:options="availableDebtors"
				options-value-field="id"
				options-display-field="displayValue"
				:disabled="disabled"
				content-size="xl"
				:render-option-as-html="true"
				required
			>
				<md-option v-if="allowAddDebtor" :value="addNewDebtorOptionValue" slot="before">
					<div class="flex flex_center">
						<i class="fa fa-pencil-square-o font_lg" aria-hidden="true" style="width: 20px;"></i>
						<span>{{ $t('seller.upload.availableDebtor.editOrAddDebtor') }}</span>
					</div>
				</md-option>
			</TbSelect>
			<span v-if="error" class="validation-error">{{ error }}</span>
		</md-field>
	</div>
</template>
<script>

import {navigationPaths} from "@/common/navigation/navigationPaths";

export default {
	props: {
		labelText: { type: String, default: "common.debtor" },
		api: { type: Function },
		callback: { type: Function },
		error: { type: Boolean, default: "" },
		value: { type: [Object, String], default: "" },
		disabled: { type: Boolean, default: false },
		allowAddDebtor: { type: Boolean, default: true }
	},
	data() {
		return {
			moduleValue: "",
			availableDebtors: [],
			availableDebtorsLoaded: false,
			addNewDebtorOptionValue: -1
		};
	},
	mounted() {
		this.loadAvailableDebtors();
	},
	methods: {
		loadAvailableDebtors() {
			this.api()
				.then(res => {
					this.availableDebtors = res.map(item => {
						return {
							...item,
							displayValue: this.getDisplayValue(item)
						};
					});

					this.availableDebtorsLoaded = true;
					this.changeOption();

          if (this.callback) {
            this.callback(res);
          }
				})
				.catch(this.toast);
		},
		redirectToDebtorManagement: function() {
			this.$emit("redirect");
			this.$router.push(navigationPaths.seller.debtors);
		},
		onSelect() {
			if (this.moduleValue !== this.addNewDebtorOptionValue) {
				if (!this.selectedDebtorData || this.selectedDebtorData.dataComplete) {
					this.$emit("input", this.selectedDebtorData);
				} else {
					//todo begin: does not work correctly! should set selectedDebtorData back to empty
					this.$nextTick(() => {
						this.moduleValue = ""
						this.$emit("input", this.selectedDebtorData);
					});
					//todo end: does not work correctly! should set selectedDebtorData back to empty

					let option = {
						msg: this.$t("seller.upload.availableDebtor.dataIncomplete"),
						confirmButtonText: this.$t("dashSideNav.Debtor.Management"),
						confirmFun: this.redirectToDebtorManagement,
					};
					this.alert(option);
				}
			} else {
				this.redirectToDebtorManagement();
			}
		},
		changeOption() {
			if (!this.availableDebtorsLoaded) {
				return;
			}

			if (this.value) {
				this.moduleValue = this.value;
				if (!this.selectedDebtorData) {
					this.availableDebtors.push({
						...this.value,
						// TODO: DEV-6472: this does not work correctly, since this just shows the ID as display name. We need to correctly resolve the full data object. When fixing this, also check how this behaves with the "dataComplete" logic.
						displayValue: this.moduleValue
					});
				}
			} else {
				this.moduleValue = "";
			}
		},
		getDisplayValue(data) {
			let namePart = data.dataComplete ? data.name : "<b class='deep_warn_color'>" + data.name + "</b>";
			return namePart + " - " + data.city + (data.taxNumber ? "(" + data.taxNumber + ")" : "");
		},
	},
	computed: {
		selectedDebtorData() {
			return this.availableDebtors.find(option => option.id === this.moduleValue);
		},
    label() {
      return this.$t(this.labelText);
    }
	},
	watch: {
		value() {
			this.changeOption();
		}
	}
};
</script>